const SystemCanvasModuleTypes = {
  GET_DEV_ORDER_MODULE_DATA_WITH_SOURCE: 'GET_DEV_ORDER_MODULE_DATA_WITH_SOURCE',
  GET_DEV_ORDER_MODULE_TAB_DETAILS: 'GET_DEV_ORDER_MODULE_TAB_DETAILS',
  UPDATE_DEV_ORDER_MODULE: 'UPDATE_DEV_ORDER_MODULE',
  CLEAR_DEV_ORDER_MODULE_DATA: 'CLEAR_DEV_ORDER_MODULE_DATA',
} as const;

export default SystemCanvasModuleTypes;

export type SystemCanvasModuleActionType = typeof SystemCanvasModuleTypes[keyof typeof SystemCanvasModuleTypes];
